export default __webpack_public_path__ + "static/media/trainer.5357fc9a.png";